import { apiInstance } from "@/api/instance";

export default async function (userId, data) {
  return apiInstance.post(`/user/${userId}`, data);
}
